// Simple select2 component.
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    $(this.element).select2({ theme: 'bootstrap4', width: '100%' })
  }
}
